import type { PayloadAction } from '@reduxjs/toolkit';
import { createReducer } from '@reduxjs/toolkit';
import changeThreadHighlightMode, {
  changeRecipientFilter,
  changeTranslationMode,
  collapseLeftPanel,
  openAttachment,
  showMoreLikeThis,
} from 'actions/envelopeView';

export type EnvelopeViewState = {
  threadHighlightMode: boolean;
  translationMode: boolean;
  attachmentOpen: boolean;
  collapsedLeftPanel: boolean;
  showMoreLikeThis: boolean;
  recipientFilter: string[];
};

type EnvelopeViewReducer<P = void> = (
  state: EnvelopeViewState,
  action: PayloadAction<P>
) => EnvelopeViewState;

const initialState: EnvelopeViewState = {
  threadHighlightMode: false,
  translationMode: true,
  attachmentOpen: false,
  collapsedLeftPanel: false,
  showMoreLikeThis: false,
  recipientFilter: [],
};

const handleChangeThreadHighlightMode: EnvelopeViewReducer<boolean> = (state, { payload }) => ({
  ...state,
  threadHighlightMode: payload,
});

const handleChangeTranslationMode: EnvelopeViewReducer<boolean> = (state, { payload }) => ({
  ...state,
  translationMode: payload,
});

const handleOpenAttachment: EnvelopeViewReducer<boolean> = (state, { payload }) => ({
  ...state,
  attachmentOpen: payload,
});

const handleCollapseLeftPanel: EnvelopeViewReducer<boolean> = (state, { payload }) => ({
  ...state,
  collapsedLeftPanel: payload,
});

const handleShowMoreLikeThis: EnvelopeViewReducer<boolean> = (state, { payload }) => ({
  ...state,
  showMoreLikeThis: payload,
});

const handleChangeRecipientFilter: EnvelopeViewReducer<string[]> = (state, { payload }) => ({
  ...state,
  recipientFilter: payload,
});

const handlers = {
  [changeThreadHighlightMode.toString()]: handleChangeThreadHighlightMode,
  [changeTranslationMode.toString()]: handleChangeTranslationMode,
  [openAttachment.toString()]: handleOpenAttachment,
  [collapseLeftPanel.toString()]: handleCollapseLeftPanel,
  [showMoreLikeThis.toString()]: handleShowMoreLikeThis,
  [changeRecipientFilter.toString()]: handleChangeRecipientFilter,
};

const envelopeViewReducer = createReducer(initialState, handlers);

export default envelopeViewReducer;
